import { FormType } from '@aloft/toolkit-shared';
import { useModal } from '@aloft/toolkit-sui';

import { useState } from 'react';

import { selectFormType } from '../../redux/features/selectors/orderSelectors.ts';
import { useAppSelector } from '../../redux/hooks.ts';
import { ExportModalInternal } from './ExportModalInternal.tsx';
import type { ClickFormsExisting, ExportType } from './types.ts';

export const useExportModal = () => {
  const [exportType, setExportType] = useState<ExportType | undefined>(undefined);
  const [clickFormsExisting, setClickFormsExisting] = useState<ClickFormsExisting | undefined>(
    undefined,
  );
  const orderFormType = useAppSelector(selectFormType);
  const legacyFormType = FormType.fnma1004;
  const [formType, setFormType] = useState<FormType>(orderFormType ?? legacyFormType);
  const { Modal, openModal, isModalOpen, closeModal } = useModal();

  const ExportModal = isModalOpen ? (
    <ExportModalInternal
      Modal={Modal}
      closeModal={closeModal}
      isModalOpen={isModalOpen}
      exportType={exportType}
      setExportType={setExportType}
      clickFormsExisting={clickFormsExisting}
      setClickFormsExisting={setClickFormsExisting}
      formType={formType}
      setFormType={setFormType}
    />
  ) : null;

  return { modal: ExportModal, openModal };
};
